import { type ProColumns, ProForm, ProTable,ProFormText,ProFormItem, ProFormSelect } from "@ant-design/pro-components";
import {
	fetchADAccountList,
	fetchAsyncAdvAccount,
	fetchCennectAdvAccount,
	fetchUnCennectAdvAccount
} from "@/api/modules/AdAccount";
import { fetchAdList, fetchAdPreview } from "@/api/modules/AdMenerge";
import { Button, Form, Input, message, Modal, Select, Switch, Tag, Tooltip } from "antd";
import { useEffect, useRef, useState, useCallback } from "react";
import { accountType } from "@/pages/AdAccount/interface.typing";
import { useDebounce } from "@/utils/util";
import { useTranslation } from "react-i18next";
import refreshIcon from "@/assets/icons/account/刷新.png";
import { QuestionCircleOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import "./index.less"
import { is } from "immutable";
import { set, debounce, before } from "lodash";


export default function AccountTable(props: any) {
	const { t } = useTranslation();
   const [accountList,setAccountList] = useState<any>([])
  const [adList, setAdList] = useState<any>([]);
  const [previewList, setPreviewList] = useState<any>([
    // {
    //     "body": "<iframe src=\"https://business.facebook.com/ads/api/preview_iframe.php?d=AQKimVpiJ6BYSmW6rHCwbDAXPHlA0V_wYat1IslQiN32P3CHqwOdcKs2ceeyDPwn12I-gfMmvy7sNff-cu0rE71UBCy28ynAwrpMVfUgyu5KHPPwHzZxbsDuCowUdTqgG79AgFkUsEmpMmmIXQVYeAa37rajOVdxKQmjhILQxZmcMwCC3xg4LA9Ej7TAM_READj1gDn_g76IeEHe82VIvx1TQsEdWNdcwytTu-3XqjoheolXxDp1ZZcP02ZmEOttXKu4BR4lispf4q8xhmLIWMDBjJdwQy4vQTS4XuOADJ7mFRp7G7zuQqK60kCaFb9c6sGrj3vYIlDERNH1FvOS2-Z8OWQtbhcnwAtkjBJk9ga8xwyCGHwx7ImBt-b0omZ6S5sqNY5AbvU3nKRymx-ZbYFp_IRc9yVZWxDCKn1aE3DECwhydlUGZ_5a8znPBAogQ28&amp;t=AQI_ft1uEn3pYjUOL9c\" width=\"335\" height=\"450\" scrolling=\"yes\" style=\"border: none;\"></iframe>"
    // },
    // {
    //     "body": "<iframe src=\"https://business.facebook.com/ads/api/preview_iframe.php?d=AQLqO2PNtnB99v731VqmBvofZ8yCvD3ulOipefQyNBUikUEFHdJa-7FaQgy2yGA_BWkdsBND-gxQGGGPR106mKqmCdaLgWONb0I_8XZj67XGq1FSnbfBr-TyhPqGEBivHwezHucNLjeyFoisoowuzX5UPXBBRUDGNcFJUAbnwoNTG75mrA0RXtFOJyo_dWEVuePMZ9xyochlDkQu7-3dUyIeho-kOmSHGquzeSLn-8IBA39tt4BnCGAWh2fzTYHtpGPW4VhQymNxhKvmlwbRbRoERxMxuWZsbnEmdnmCGVsDC_BnyphnGy6Q97MMeB-8XZ95RmwO8mb3R6JOgH3nNUybLY0vbWsYFTVqS7z9tqXCXyjOLs0gaJpyFm5cnvCyF8SfDQ1_e42snjItkIpExJA-Cs4aCL0e-WO_0M28NPcnnZYKU8MI3HuNK5glynx4IbM&amp;t=AQI3GGtRfVJkbF9xs3g\" width=\"335\" height=\"450\" scrolling=\"yes\" style=\"border: none;\"></iframe>"
    // },
    // {
    //     "body": "<iframe src=\"https://business.facebook.com/ads/api/preview_iframe.php?d=AQJcbRWIMcvMZw99A2uuMxCGrVhNZozHUpOvaWlBkrB3gnGshrG9ZuN1tO3aA2jm6aV_patF01G2kkwC1Uglb-1t0U3oaHGcSmovuOXsv-J3LED8KKgM8Jk3vRj7BWLxkzkCsu8z121CdXPw3VyGPesBgLuxyZZiojhdTYLygqlMLUUm8bT4p_hfAP_pCswNzu6WSD9Bhyzge5DDFy7FKamZ9era8vhaxhMh3gLBRM5vxHYcvjCOICPB4YI1dlcmXkZTo49lnqsIf1PtDWV4fWd4gYOyWfmituiazjcEud38NIYSMozwoSSDoMBAxrVwVDcJEzrFpCaWmDbzXvE6WcA_qykVblYUwLck9bL0FB5mRaCTnudSScOHYJ4xUlyEa_7spij46L3VwDHc5Wnv88GH-x-zz4W8U_oiw_qkGXZGIjMs0ue-oeIiUnDPGBZKIcQ&amp;t=AQKPuydCPab5dkBIw4w\" width=\"335\" height=\"450\" scrolling=\"yes\" style=\"border: none;\"></iframe>"
    // },
    // {
    //     "body": "<iframe src=\"https://business.facebook.com/ads/api/preview_iframe.php?d=AQJeDnyOLbK2rhu4kwXR0O0wxxsxfoyin-YZy0rl8LLa0us3dbhmn_7fcgdTrzzh-eHMoPVW_PqtW-TU77eZSiR2_hCjfC2Gu_jRL_y4F_x0QuMktMZBWxRcCisJVzWOl6AQ2mxCwfcd1l6_0ykEKxKwMTKrg5wgzaRSqhJT1df5My_j2yXjHmZWyuKRcan5Ydm9DCEVS0lsXUfDnI84nlh-ADXcQFqgZz_09bq47KkQmKDA4v-E-qK6P_jew9iSwyKYZTFwdLGtc8MzH02YkhVnj-WeaWnHy1TiPwh6POsejp8JTrTaddgWizw2Ea1wvSMRRH2315KSaZrnPoW0LRXGMiRsSU3TL8tGTlhC9pdgdK9GftayeccT3vBT4gZwbbCtf2M8itYlowp-rBAtRo3TVa4W1GfFTxmtH7Pa67kjOiDjD1F8EDrFXe8x-SR6P48&amp;t=AQKdM1z6LM31Mb08gUY\" width=\"335\" height=\"450\" scrolling=\"yes\" style=\"border: none;\"></iframe>"
    // },
    // {
    //     "body": "<iframe src=\"https://business.facebook.com/ads/api/preview_iframe.php?d=AQIFCEfdLa09HHay5UnVPJjdZlzIfaZvWL2MBvFsfbU4HIExc05Tduc2gTm_Z-rKrPw0a5DWqQbCSUWde1Ug1w3XLxkQPlpN0MzOAGvLh9_2b_mzvZH-FEBjGVWW8pOYMIw3ccA-_HlaFmEItmeyQOY6IZRWzekiM3Eyj8S-sl7yn9ecl2kwqORkyWNRn7jnCDy1xt22s8aSFojP7vB7wLfhZZ8lx0FHCxxXrHJnvhkdzkv9ZyR1XEn8n3CwWI_s0jUp7DyRjD7if1b2QhimL8B4_zvDHSeqsruAl8Taj-I2tjVj_uZQ7ISYjmDXKVLt7c9Gy4yNKWBLrL6lKZv_glhRG57nofEu5yuzncMWnJ0sB0b0y_nMfBOexA5vgKZbDvKsI5koNmHZPkBzqB0-0J7c7vMQZYhvHieh1rc0jQKSaItBqhmEfXZw_kb_R4G1s24&amp;t=AQIR6QVhkFrRm4IrLlw\" width=\"335\" height=\"450\" scrolling=\"yes\" style=\"border: none;\"></iframe>"
    // },
    // {
    //     "body": "<iframe src=\"https://business.facebook.com/ads/api/preview_iframe.php?d=AQIhJegs8f5ivQXZPmTWzsb0_6mOe8gO5qn19WUa0bSzatX-GF0G61KM9srcklEXeBAj1HNojM36T8zwLjEbQcYRTEcxNQFZeSj8Mchh2qusM1bs9xpSP8tELNVBhXQQ7JqFSH-EReS_8pP8eKOSn-hIRlYwS24de69rVk7XZijPNUmsVjrkcEZYUGi14KOpQDtM_4MXo1MOqMuBntC5YGQ1nunpy3U26dlumw4-sUQiRO5TiEXfVUBKkiybmrW4T4_0FBbmY2thRbTskghA1SIWTRq_B6cyTuWVhYyzBbtvbevoM82IImgPA1P9FnT8gSZn3-HetqQBPUq_fe2sLp2nRQSqYtco4AbRMfgo2hr9-4CsmnyK96Fwi7JlMKCeqXqEKbBsC9WXPB2EuGk3L7AYvAHc6RTviXj2sPP8dNU7obe4O2RoACZGpmJLOIl94Tc&amp;t=AQIwmHw0Gz9lFpDCRso\" width=\"335\" height=\"450\" scrolling=\"yes\" style=\"border: none;\"></iframe>"
    // },
    // {
    //     "body": "<iframe src=\"https://business.facebook.com/ads/api/preview_iframe.php?d=AQLrrd5D-p_UlI-bJ0olbL_hP4DRliqBEEIj2hmzxqTOcFY2XpUd7u-zaIf-1s28K2y5Je1AlPovc0kIQPKCwmyYW7RZJ95JrNh94idNcUqvttys3R1viC1voiOrhMeIqoJpB8m5_tqHNWjJwPJ_9fJmvgAnQtfGNt-7sjkR7nHX_IYH5OIyUSh1JRcpMP0vUjB4jh4FMjz2wzmCm_o3dlDN8oiK4l60nAUyPCNdCFINdE9xQdQzhGouDieJq6wF4D3SEJBvDesurcOYyI_hk_83vELqHH5M0J5szUMuZhhxuHaulVLH96soMX6PaRrnIryQR0RXUWWnD630IBUgw2Dml1HHklMks-EDHiKy7g7bKZ3cVYSLlldUyHCAnQjAjvTRNbsgbwPgUdAqsXf_kzVst429D-3LCrhC18ZhdXW_Eqab28PCYhFRpH1FzlkozYM&amp;t=AQLvB2uLVTej5IXjbOM\" width=\"335\" height=\"450\" scrolling=\"yes\" style=\"border: none;\"></iframe>"
    // },
    // {
    //     "body": "<iframe src=\"https://business.facebook.com/ads/api/preview_iframe.php?d=AQIIazuiQUzqoj4l_4aOIC9jOSWiheg8R3BTr7sULGOtOSU3mwyA7SjOSFRhaplzbnirqEIj51L_apZ_Rwsj2s6rNC1LuDsHvkbDJstV7k9SU4F4ycA1WeiSSXLJfRES_vPn3-IKyD2shP1WQXS8rYmiDEekCv_WvMJ4dNDHi7ZApIZ7hklFQl2NdlWzyPuQqhYDZYlMsM3Yh-ulqGNYskahQUlw6f6sTVi15OyJFnn69fUDu9fSWn0BmO4UGEN_rhadcX7eKpfYJn0vHWDLbQrimQn1OE9urBIXzvB9FHhMWChdn8Dz7FjsJDdsIvGjBycQDgDEoI79KnKPfbf1EqtX4dNRv5BRumETsvNHnK4P1Ut_rk-RONE0Ce28grtDUl4WDXyb9-Z3j8dq3_epg4WdAdciS_DO81nFuxDO_5boYIRzjsdjdtMRThad1rc6NDo&amp;t=AQK3yJD4sM3q1NqXwyI\" width=\"335\" height=\"450\" scrolling=\"yes\" style=\"border: none;\"></iframe>"
    // },
    // {
    //     "body": "<iframe src=\"https://business.facebook.com/ads/api/preview_iframe.php?d=AQJ0SDl9o_HU4a_6jXWvj44vMCH_4kAJSrUKQT3m3N4sbK7SKCCh3vTAbI-ujrinTtYXAP3KbGgCbkfHk4a1jqEodgfPQIDy1ig6YFYnZ8ooTAkds5uD505BmZbbDy-bgdwC8byhE9DH6AFr5Ki0e85ep2HL0u5pLewIJnNFE-v8d0qFjTKtO-qW4A-qF2m0E2cjykyC6Cm1n4078lBhnK92EbYZfdpFyIBHKfjpmzncJtUsMuzdmPH2oSnJcQO30YvuyYuU18W09eZ-lY-vQ6Q_JiqIWrVEOXJFbGvJCqKRXY_keBNqCgKHUYTQ5vUdHcFd3NLm3Liiw2tShxTQZD_229VFrXp6007P053V6jbpq9Tj7uqQOT8Ivk-pXXOc_dnQqJs3FyvPlriwg5YaHq9yBwzSmTgzbfCQNwXjaFimXVrhH8Olqk6xpymndcX4kbk&amp;t=AQJV7tRzKkudxnpkHhM\" width=\"335\" height=\"450\" scrolling=\"yes\" style=\"border: none;\"></iframe>"
    // },
    // {
    //     "body": "<iframe src=\"https://business.facebook.com/ads/api/preview_iframe.php?d=AQLKIAiuSuhg6xKccE4rLXnC7gZn_OcwxMZGJ3i_jHkwMLlyhT_F16sQhvLeX-ELvUp3uiPV_kNg0efzgVvBMaNIIC8W_54Km-pRnqEbS_xTL6j1to-Q4YiR9-BCSzJiK4VsXhpHRDuzty1aGQWs9Y_u4PfY5m_eroFMGnJ5m_q_QRnrlqSHMQHVNipRHGMOAXGKzkcGJSgpT_5i7j70LMAX4CvH1yB33siQ9VL4TxlI73lDyE28PedODyZ-nkmOJ5chnk_QUYY_rtsmvUgSHeVbYJKanV_cjE4E_3reDYUVdGoq01P9Rkm4ypYD-5TdP0j4REHlyWPw-dC7akiS-RJVIDIy0tDy8pAnm1mpnB3P6vQ6W8NSk3WuYCtbpiEGI_c4lieNxhTjAH8jHLEjgXc5Z8K8f95S0ovvYNaNPQ3eCVjrZq4TtdQzmaQbFLXT3LY&amp;t=AQLP_qAcIJ5XelDrN54\" width=\"335\" height=\"450\" scrolling=\"yes\" style=\"border: none;\"></iframe>"
    // }
    ])
    
    const [cursorBefore, setCursorBefore] = useState(null);
    const [cursorAfter, setCursorAfter] = useState(null);
   const [form] = Form.useForm();

   useEffect(() => {
    fetchData()
   }, [])

   const handleScroll = useCallback(
    debounce((event) => {
      console.log("before", cursorBefore, "after", cursorAfter, );
     
      const { scrollTop, scrollHeight, clientHeight } = event.target;
      if (scrollTop + clientHeight >= scrollHeight) {
        getAdList({upLevelId:form.getFieldsValue().advId,limit:10,after:cursorAfter,before:cursorBefore});
      }
    }, 300),
    [form]
  );

	const fetchData = async params => {
		let res = await fetchADAccountList({
				...params,
                isActive:1
			});

        if (res.code === 200) {
           setAccountList(res.data.list)
        }

		
	};

    const matchAccountStatus = (status) => {
        switch (status) {
          case 0:
            return <Tag color="red">未连接</Tag>;
          case 1:
            return <Tag color="green">已连接</Tag>;
          default:
            return <Tag color="default">未状态</Tag>;
        }
      };

      const handleSubmit = () => {
        const values = form.getFieldsValue()

        console.log(values)
        getAdList({upLevelId:values.advId,limit:10})
        /** 调用获取帖子的接口 */
      };

      const getAdList = async (params) => {
        const res = await fetchAdList(params);
        if (res.code === 200) {
          setAdList(res.data.data);
          setCursorBefore(res.data.before);
          setCursorAfter(res.data.after);
          
          const promises = res.data.data.map((item) =>
            fetchAdPreview({ adIdOrAdCreativeId: item.id, adFormat: "MOBILE_FEED_STANDARD" })
          );
          Promise.all(promises).then((results) => {
            const newPreviewList = results.map((res) => {
              if (res.code === 200) {
                return res.data[0];
              }
            });
            setPreviewList([...previewList, ...newPreviewList]);
          });
        }
      };

      console.log("previewList", previewList);
	return (
		<div className="adMenergePage">
        <div className="adMenergeContainer">
		
        <ProForm
            labelCol={{ span: 12 }}
            wrapperCol={{ span: 20 }}
            submitter={false}
            form={form}
            onFinish={async (values) => {
                props.formRef.current?.submit();
            }}
        >
            <ProFormSelect name="advId"
             options={accountList} 
             label="Ad Account Name" 
             fieldProps={{ placeholder: "Please enter ad account name",
                fieldNames: { label: 'advName', value: 'advId', },
                optionRender: (item: any) => {
                    console.log(item);
                    return (
                      <div className="accountItem">
                        <div>{item.data.advName}</div>
                        <div>{matchAccountStatus(item.data.isActive)}</div>
                      </div>
                    );
                  },
              }} 
             placeholder="Please enter ad account name" />        
      <ProFormItem>

      </ProFormItem>
        </ProForm>
        <div className="previewContainer" onScroll={handleScroll}>
          {previewList.map((item, index) => {
            return (
             
             
                <div key={item +index} className="previewItem" dangerouslySetInnerHTML={{ __html: item.body }} />
            
            );
          })}
        </div>
        <div className="buttonContainer">
            <div className="button">
            <Button onClick={handleSubmit}>确定</Button>
            </div>
        </div>

			{/*<div className={"hidden_tip"}>1 ad account was hidden because it cannot be connected. Show all ad accounts</div>*/}
			
		</div>
		</div>
	);
}
